import {
  DataStore,
  OpType,
  PersistentModelConstructor,
} from '@aws-amplify/datastore';
import { Observable, Subject } from 'rxjs';

export type PersistentModel = any;
// PersistentModelConstructor<
//   Readonly<
//     {
//       id: string;
//     } & Record<string, any>
//   >,
//   {
//     readOnlyFields: 'createdAt' | 'updatedAt';
//   }
// >;

export class DataStoreSources<Model> {
  private createSource = new Map();
  private updateSource = new Map();
  private deleteSource = new Map();
  sub: any | null = null;

  onCreated(typeName: string): Observable<Model> {
    if (!this.createSource.has(typeName))
      this.createSource.set(typeName, new Subject());
    return this.createSource.get(typeName).asObservable();
  }
  onUpdated(typeName: string): Observable<Model> {
    if (!this.updateSource.has(typeName))
      this.updateSource.set(typeName, new Subject());
    return this.updateSource.get(typeName).asObservable();
  }
  onDeleted(typeName: string): Observable<Model> {
    if (!this.deleteSource.has(typeName))
      this.deleteSource.set(typeName, new Subject());
    return this.deleteSource.get(typeName).asObservable();
  }

  observeDataStore(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }

    this.sub = DataStore.observe().subscribe((msg: any) => {
      this.publishToSubscribers(msg.element as Model, msg.model, msg.opType);
    });
  }

  private publishToSubscribers(
    element: Model,
    model: PersistentModel,
    operationType: OpType,
  ) {
    switch (operationType) {
      case OpType.INSERT:
        this.onCreatePublish(element, model);
        break;
      case OpType.UPDATE:
        this.onUpdatePublish(element, model);
        break;
      case OpType.DELETE:
        this.onDeletePublish(element, model);
        break;
      default:
        // console.error('Operation does not exist');
        break;
    }
  }

  private onCreatePublish(element: Model, model: PersistentModel) {
    if (this.createSource.has(model.name)) {
      this.createSource.get(model.name).next({ ...element });
    }
  }
  private onUpdatePublish(element: Model, model: PersistentModel) {
    // QUESTION: why was there a query here before publishing the element
    // DataStore.query(model, element.id).then((_element) => {

    if (this.updateSource.has(model.name)) {
      this.updateSource.get(model.name).next({ ...element });
    }
  }
  private onDeletePublish(element: Model, model: PersistentModel) {
    if (this.deleteSource.has(model.name)) {
      this.deleteSource.get(model.name).next({ ...element });
    }
  }
}
